module.exports = __webpack_public_path__ + "img/2019jucan-1.03354b49.jpg";